import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/components/pilotPage/pilotPage'),
      name: 'pilotPage'
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '欢迎登录',
        requireAuth: true
      }
    },
    {
      path: '/register',
      // component: () => import('@/components/register/register'),
      name: 'Register',
      meta: {
        title: '欢迎注册',
        requireAuth: true
      }
    },
    {
      path: '/productInfo',
      component: () => import('@/components/productInfo/productInfo'),
      name: 'productInfo'
    },
    {
      path: '/pcPreview',
      component: () => import('@/components/productInfo/picture/pcPreview'),
      name: 'pcPreview'
    },
    {
      path: '/pcDetail',
      component: () => import('@/components/productInfo/picture/pcDetail'),
      name: 'pcDetail'
    },
    // {
    //   path: '/personal',
    //   component: () => import('@/components/personal/personalHome'),
    //   name: 'personal',
    //   redirect: '/personalHome',
    //   meta: {
    //     title: '个人中心',
    //     requireAuth: true,
    //     jumpAuth: true
    //   }
    // },
    {
      path: '/account',
      component: () => import('@/components/account/account'),
      name: 'gwc',
      meta: {
        title: '购买商品',
        requireAuth: true
      }
    },
    {
      path: '/vip',
      component: () => import('@/components/vip/vip'),
      name: 'vip',
      meta: {
        title: '确认支付'
      }
    },
    // {
    //   path: '/copyyy',
    //   component: () => import('@/components/copyyy/copyyy'),
    //   name: 'copyyy',
    // },
    {
      path: '/szcc',
      component: () => import('@/components/secondPage/szcc/szcc'),
      name: 'szcc',
      redirect: '/szcc_qxtx',
      children:[
        {
          path: '/szcc_qxtx',
          component: () => import('@/components/secondPage/szcc/components/qxtx'),
          name: 'szcc_qxtx',
        },{
          path: '/szcc_swcj',
          component: () => import('@/components/secondPage/szcc/components/swcj'),
          name: 'szcc_swcj',
        },{
          path: '/szcc_fytx',
          component: () => import('@/components/secondPage/szcc/components/fytx'),
          name: 'szcc_fytx',
        },{
          path: '/szcc_cctm',
          component: () => import('@/components/secondPage/szcc/components/cctm'),
          name: 'szcc_cctm',
        },
      ]
    },
    {
      path: '/homePage',
      component: () => import('@/components/homePage/homePage'),
      name: 'homePage',
      redirect: '/index',
      meta: {
        title: '首页',
        requireAuth: true
      },
      children:[
        {
          path: '/search',
          component: () => import('@/components/search/search'),
          name: 'search',
          meta: {
            title: '搜索'
          }
        },
        {
          path: '/packageDetails',
          component: () => import("@/components/productInfo/packageDetails/packageDetails"),
          name: 'packageDetails',
        },
        {
          path: '/courseDetail',
          component: () => import("@/components/productInfo/packageDetails/courseDetail"),
          name: 'courseDetail',
        },
        {
          path: '/gwc',
          component: () => import('@/components/gwc/gwc'),
          name: 'gwc',
          meta: {
            title: '我的购物车'
          }
        },{
          path: '/pay',
          // component: () => import('@/components/pay/pay'),
          name: 'pay',
          meta: {
            title: '确认支付',
            requireAuth: true
          }
        },
        {
          path: '/index',
          component: () => import('@/components/homePage/index/index'),
          name: 'index'
        },
        {
          path: '/secondPage',
          component: () => import('@/components/secondPage/secondPage'),
          name: 'secondPage',
          children:[
            {
              path: '/hyfw',
              component: () => import('@/components/secondPage/hyfw/hyfw'),
              name: 'hyfw'
            },
            {
              path: '/xszt',
              component: () => import('@/components/secondPage/xszt/xszt'),
              name: 'xszt'
            },
            {
              path: '/zxkc',
              component: () => import('@/components/secondPage/zxkc/zxkc'),
              name: 'zxkc'
            },
            {
              path: '/zxsc',
              component: () => import('@/components/secondPage/zxsc/zxsc'),
              name: 'zxsc'
            },{
              path: '/jzgfsjk',
              component: () => import('@/components/secondPage/jzgfsjk/jzgfsjk'),
              name: 'jzgfsjk',
            },{
              path: '/ctjlspzyk',
              component: () => import('@/components/secondPage/ctjlspzyk/ctjlspzyk'),
              name: 'ctjlspzyk',
            },
              
          ]
        },
        {
          path: '/zdtj',
          component: () => import('@/components/secondPage/zdtj/zdtj'),
          name: 'zdtj'
        },
        {
          path: '/newsInfo',
          component: () => import('@/components/newsInfo/newsInfo'),
          name: 'newsInfo'
        },
        {
          path: '/route',
          component: () => import('@/components/route/route'),
          name: 'route'
        },
        {
          path: '/gjdt',
          component: () => import('@/components/gjdt/gjdt'),
          name: 'gjdt'
        }
        
      ]
    },

    // 移动端页面路由
    {
      path: '/home',
      component: () => import('@/components/mobilePage/mHomePage/home'),
      name: 'home',
      meta: {
        title: '首页'
      }
    },
    // {
    //   path: '/mLogin',
    //   component: () => import('@/components/mobilePage/mLogin/mLogin'),
    //   name: 'mLogin',
    //   meta: {
    //     title: '登录'
    //   }
    // },
    {
      path: '/mine',
      component: () => import('@/components/mobilePage/mLogin/mine'),
      name: 'mine',
      meta: {
        title: '我的',
        
      }
    },
    {
      path: '/mNewsInfo',
      component: () => import('@/components/mobilePage/mNewsInfo/mNewsInfo'),
      name: 'mNewsInfo',
      meta: {
        title: '',
        
      }
    },
    {
      path: '/mKeyRecommend',
      component: () => import('@/components/mobilePage/mKeyRecommend/mKeyRecommend'),
      name: 'mKeyRecommend',
      meta: {
        title: '',
        
      }
    },
    {
      path: '/mserve',
      component: () => import('@/components/mobilePage/hotBro/service'),
      name: 'mserve',
      meta: {
        title: '',
        // jumpAuth: true
      }
    },
    {
        path: '/mhyfw',
        component: () => import('@/components/mobilePage/mHyfw/hyfw'),
        name: 'mhyfw',
        meta: {
          title: '行业服务',
          // jumpAuth: true
        }
      },
    {
      path: '/archGallery',
      component: () => import('@/components/mobilePage/archGallery/archGallery'),
      name: 'archGallery',
      meta: {
        title: '建筑图库',
        // requireAuth:true
      }
    },
    // {
    //   path: '/picfall',
    //   component: () => import('@/components/mobilePage/picfall/picfall'),
    //   name: 'picfall',
    //   meta: {
    //     title: '建筑图库2',
    //     // requireAuth:true
    //   }
    // }, 
    {
      path: '/galleryDto',
      component: () => import('@/components/mobilePage/archGallery/galleryDto'),
      name: 'galleryDto',
      meta: {
        title: '建筑图库',
        // jumpAuth: true
      }
    },
    // {
    //   path: '/mCatalog',
    //   component: () => import('@/components/mobilePage/archGallery/mCatalog'),
    //   name: 'mCatalog',
    //   meta: {
    //     title: '图库列表',
    //     // jumpAuth: true
    //   }
    // },
    // {
    //   path: '/mPreview',
    //   component: () => import('@/components/mobilePage/archGallery/mPreview'),
    //   name: 'mPreview',
    //   meta: {
    //     title: '图集轮播',
    //     // jumpAuth: true
    //   }
    // },
    // {
    //   path: '/mDetail',
    //   component: () => import('@/components/mobilePage/archGallery/mDetail'),
    //   name: 'mDetail',
    //   meta: {
    //     title: '大图',
    //     // jumpAuth: true
    //   }
    // },
    {
      path: '/bouRes',
      component: () => import('@/components/mobilePage/boughtRes/boughtRes'),
      name: 'bouRes',
      meta: {
        title: '已购资源',
        // jumpAuth: true
      }
    },
    // {
    //   path: '/myFav',
    //   component: () => import('@/components/mobilePage/myFav/myFav'),
    //   name: 'myFav',
    //   meta: {
    //     title: '我的阅读'
    //   }
    // },
    {
      path: '/recBuy',
      component: () => import('@/components/mobilePage/recBuy/recBuy'),
      name: 'recBuy',
      meta: {
        title: '我的荐购',
        // jumpAuth: true
      }
    },
    {
      path: '/goodsDto',
      component: () => import('@/components/mobilePage/goodsDto/goodsDto'),
      name: 'goodsDto',
      meta: {
        title: '商品详情',
        // jumpAuth: true
      }
    },
    // {
    //   path: '/mOrder',
    //   component: () => import('@/components/mobilePage/mobileOrder/mOrderList'),
    //   name: 'mOrder',
    //   meta: {
    //     title: '我的订单'
    //   }
    // },
    // {
    //   path: '/course',
    //   component: () => import('@/components/mobilePage/coursePlay/coursePlay'),
    //   name: 'course',
    //   meta: {
    //     title: '课程详情',
    //     // jumpAuth: true
    //   }
    // },
    {
      path: '/download',
      component: () => import('@/components/mobilePage/coursePlay/download'),
      name: 'download',
      meta: {
        title: '下载'
      }
    },
    {
      path: '/msearch',
      component: () => import('@/components/mobilePage/mSearch/mSearch'),
      name: 'msearch',
      meta: {
        title: '搜索'
      }
    },
    {
      path: '/searesu',
      component: () => import('@/components/mobilePage/mSearch/searchResu'),
      name: 'searesu',
      meta: {
        title: '搜索结果'
      }
    },
    {
      path: '/myfoot',
      component: () => import('@/components/mobilePage/myfootPrint/myfootPrint'),
      name: 'myfoot',
      meta: {
        title: '我的足迹'
      }
    },
    // {
    //   path: '/myfoot1',
    //   component: () => import('@/components/mobilePage/myfootPrint/myfootPrint1'),
    //   name: 'myfoot1',
    //   meta: {
    //     title: '我的足迹'
    //   }
    // },
    {
      path: '/aboutUs',
      component: () => import('@/components/mobilePage/aboutUs/aboutUs'),
      name: 'aboutUs',
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/mineInfo',
      component: () => import('@/components/mobilePage/mobilePersonalInfo/mobilePersonalInfo'),
      name: 'mineInfo',
      meta: {
        title: '个人信息'
      }
    },
    // {
    //   path: '/shoppingCart',
    //   component: () => import('@/components/mobilePage/goods-shop/goods-shop'),
    //   name: 'shoppingCart',
    //   meta: {
    //     title: '购物车'
    //   }
    // },
    {
      path: '/topay',
      component: () => import('@/components/mobilePage/pay/topay'),
      name: 'topay',
      meta: {
        title: '支付'
      }
    },
    {
      path: '/confirmOrder',
      component: () => import('@/components/mobilePage/pay/confirmOrder'),
      name: 'topconfirmOrderay',
      meta: {
        title: '确认订单'
      }
    },
    {
      path: '/map',
      component: () => import('@/components/mobilePage/ChinaMap/ChinaMap'),
      name: 'map',
      meta: {
        title: '古建地图'
      }
    },
    {
      path: '/paysuccess',
      component: () => import('@/components/mobilePage/pay/paysuccess'),
      name: 'paysuccess',
      meta: {
        title: '支付成功'
      }
    }, 
    {
      path: '/payfail',
      component: () => import('@/components/mobilePage/pay/payfail'),
      name: 'payfail',
      meta: {
        title: '支付失败'
      }
    },   
    {
      path: '/unsubscribe',
      component: () => import('@/components/mobilePage/unsubscribe/unsubscribe'),
      name: 'unsubscribe',
      meta: {
        title: '注销账号'
      }
    },
    {
      path: '/unsubscribeSuccess',
      component: () => import('@/components/mobilePage/unsubscribeSuccess/unsubscribeSuccess'),
      name: 'unsubscribeSuccess',
      meta: {
        title: '注销成功'
      }
    },
    {
      path: '/goods',
      component: () => import('@/components/mobilePage/goodsList/goodsList'),
      name: 'goods',
      meta: {
        title: '商品清单'
      }
    },
    {
      path: '/mPreview',
      component: () => import('@/components/mobilePage/mPreview/mPreview'),
      name: 'goods',
      meta: {
        title: '图片详情'
      }
    },
    {
      path: '/mpDetail',
      component: () => import('@/components/mobilePage/mPreview/mpDetail'),
      name: 'mpDetail',
      meta: {
        title: '图片详情'
      }
    },
    {
      path: '/mobile_privacy',
      component: () => import('@/components/mobilePage/mobile_privacy/mobile_privacy'), //移动端<隐私协议>
      name: 'mobile_privacy'
    },
    {
      path: '/app_privacy',
      component: () => import('@/components/mobilePage/mobile_privacy/app_privacy'), //移动端<隐私协议>
      name: 'app_privacy'
    },

  ],
  scrollBehavior (to, from, savedPosition) {
    return {x:0,y:0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js